import * as React from "react";
import Select from "components/common/Select";
import Direction from "views/logic/aggregationbuilder/Direction";
const SortDirectionSelect = ({ direction = void 0, disabled = false, onChange = () => {
} }) => /* @__PURE__ */ React.createElement(
  Select,
  {
    disabled,
    clearable: false,
    options: [
      { label: "Ascending", value: "Ascending" },
      { label: "Descending", value: "Descending" }
    ],
    onChange: (value) => onChange(Direction.fromString(value)),
    placeholder: disabled ? "No sorting selected" : "Click to select direction",
    value: direction != null ? direction : null
  }
);
export default SortDirectionSelect;
